import { reasonOptions } from '../../../data';

export function buildUserName(name) {
  const [firstName, ...lastName] = name.split(' ');
  const allLastNames = lastName.join(' ');

  return { firstName, lastName: allLastNames };
}

export const personalEmailProviders = [
  '@gmail.com',
  '@aol.com',
  '@outlook.com',
  '@mail.com',
  '@yahoo.com',
  '@hotmail.com',
];

export function buildRegex(emailList) {
  const concatenatedList = emailList.join('|');
  return `^((?!(${concatenatedList})).)*$`;
}

export const doesNotIncludePersonalEmailProviders = new RegExp(buildRegex(personalEmailProviders));

/**
 * Convert array of options to Array of object with label and value
 * @param {Array<string | {option: string; authType: string}>} listItems
 * @returns
 */
export function listToOptions(listItems) {
  return listItems.map((entry) => {
    if (typeof entry === 'string')
      return {
        label: entry,
        value: entry,
      };

    return {
      label: entry.option,
      value: entry.option,
      authType: entry.authType,
    };
  });
}

/**
 * Get authType from reason selection
 * @param {string} reason
 * @returns {string} authType
 */
export function getAuthTypeFromReasonOption(reason) {
  return reasonOptions.find(({ option }) => option === reason).authType ?? '';
}
